'use client';
/** @jsxImportSource @emotion/react */

import type { AccordionDetailsProps as MuiAccordionDetailsProps } from '@mui/material/AccordionDetails';

import MuiAccordionDetails from '@mui/material/AccordionDetails';

interface AccordionDetailsProps extends MuiAccordionDetailsProps {
  component?: React.ElementType;
}

export type { AccordionDetailsProps };
export const AccordionDetails: React.FC<AccordionDetailsProps> =
  MuiAccordionDetails;

AccordionDetails.displayName = 'AccordionDetails';
